import * as Actions from 'src/store/actions/pdfAnnotator.actions';

const initialState = {
    pdfAnnotatorDrawerOpen: false,
};

const pdfAnnotatorReducer = (state = initialState, action) => {
    switch (action.type) {

        // setters
        case Actions.PDF_ANNOTATOR_SEARCH_DRAWER_TOGGLE: {

            const toggled = !state.pdfAnnotatorDrawerOpen;

            return {
                ...state,
                pdfAnnotatorDrawerOpen: toggled,
            };
        }

        default: {
            return state;
        }
    }
};

export default pdfAnnotatorReducer;
